import {DraggableId, DroppableId} from '../../../../../lib/components/drag-n-drop';

export function toDraggableId(index: number): DraggableId {
  return index.toString(10);
}

export function indexFromDraggableId(draggableId: DraggableId): number {
  return parseInt(draggableId, 10);
}


export function toDroppableId(index: number): DroppableId {
  return index.toString(10);
}

export function indexFromDroppableId(droppableId: DroppableId | null): number | null {
  if (droppableId === null || droppableId.startsWith(ignorePrefix))
    return null;
  return parseInt(droppableId, 10);
}

const ignorePrefix = 'ignore-';

export function ignoreDroppableId(index: number) {
  return ignorePrefix + index.toString(10);
}
